import { Navigate, Route, Routes } from 'react-router-dom';

import { DefaultLayout2 } from '@web/app/shared/components/default-layout';

import { NewHomePage, ProductDetailPage, ProjectSettingsPage, WorkspaceSettingsPage } from '../pages';

export const NewHomeRoutes = () => {
    return (
        <Routes>
            <Route element={<DefaultLayout2 />}>
                {/* Workspace list route */}
                <Route path="/" element={<NewHomePage />} />

                {/* Workspace-specific routes */}
                <Route path="/:workspaceId" element={<NewHomePage />} />
                <Route path="/:workspaceId/settings" element={<WorkspaceSettingsPage />} />

                {/* Project-specific routes */}
                <Route path="/:workspaceId/p/:projectId" element={<NewHomePage />} />
                <Route path="/:workspaceId/p/:projectId/settings" element={<ProjectSettingsPage />} />
                <Route path="/:workspaceId/p/:projectId/products/:productId" element={<ProductDetailPage />} />

                <Route path="*" element={<Navigate to="/w"></Navigate>}></Route>
            </Route>
        </Routes>
    );
};
